import React, { useEffect, useState } from 'react';

import { getAirlineLogo } from 'utils/generic';

interface Props {
  airline: string;
  className?: string;
}

const AirlineLogo = ({ airline, className }: Props) => {
  const [srcImage, setSrcImage] = useState('/corporate/images/generic-airline.svg');

  useEffect(() => {
    const img = new Image();
    img.src = getAirlineLogo(airline);
    img.onload = () => setSrcImage(img.src);
    return () => {
      img.onload = null;
    };
  }, [airline]);

  return <img className={className || ''} src={srcImage} alt="" />;
};

export default AirlineLogo;
